<template>
<div class="update-leaps-meditation-overlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="updateHideUpdateLeapsMeditationOverlayFlag($event)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  <span>Title</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px padding-right-0Px">
                      <input type="text" class="form-control" v-model="objToPass.MeditationTitle" :maxlength="maxLength">
                    </div>
                  </div>
                </div> 
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style padding-right-0Px">
                  <span>Video Url(s)</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <video-quality-control :parentElementObj="objToPass" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                      <video-quality-control :parentElementObj="objToPass" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValue"></video-quality-control>
                      <video-quality-control :parentElementObj="objToPass" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  Caption File
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">

                    <div class="col-sm-12 padding-left-0Px padding-right-0Px">
                      <input type="file" id="vttFile" accept=".vtt">
                    </div>

                    <div class="col-sm-12 padding-left-0Px padding-right-0Px text-align-left margin-Top-3Perc" v-if="objToPass.CaptionUrl !== undefined && objToPass.CaptionUrl !== 'undefined' && objToPass.CaptionUrl !== null && objToPass.CaptionUrl !== 'null' && objToPass.CaptionUrl !== ''">
                      <span>
                        <a target="_blank" class="text-color-blue" :href="objToPass.CaptionUrl"><u>Download File</u></a>
                      </span>
                      <span class="margin-left-1Perc margin-right-1Perc">|</span>
                      <span class="text-color-blue cursor-pointer" @click="performClickOperation($event, 'delete_vtt')"><u>Delete Existing File</u></span>
                    </div>
                  </div>
                </div> 
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style padding-right-0Px">
                </div>
                <div class="col-md-4 col-lg-4">
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px padding-right-0Px">
                    </div>
                  </div>
                </div> 
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style padding-right-0Px">
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  Audio Url
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px create-lesson-label-text-style">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="text" class="form-control" v-model="AudioURLValue">
                    </div>
                  </div>
                </div> 
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style padding-right-0Px"> 
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px padding-right-0Px">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                </div>
                <div class="col-md-3 col-lg-3 padding-right-0Px create-lesson-label-text-style">
                  <div class="form-group">
                    <div v-if="objToPass.AudioUrl !== undefined && objToPass.AudioUrl !== null && objToPass.AudioUrl !== 'null' && objToPass.AudioUrl !== '' && dmAdminUtils.isValidUrl(AudioURLValue.trim()) && dmAdminUtils.checkForAudioFileExtesion(AudioURLValue.trim())">
                      <audio controls class="audio-width" controlsList="nodownload">
                        <source :src="objToPass.AudioUrl" type="audio/mp3">
                      </audio>
                    </div>
                    <div v-else class="text-color-red">
                      Not Found.
                    </div>
                  </div>
                </div> 
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style padding-right-0Px"></div>
                <div class="col-md-4 col-lg-4"></div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <span>Description</span>
                </div>
                <div class="col-md-9 col-lg-9 padding-left-0Px">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <tinymce id="d1" v-model="objToPass.MeditationDescription"></tinymce>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateLeapsMeditation">Update</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteVttFile"></confirmation-alert>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
 </div>
 </div>
</template>

<script>
import tinymce from 'vue-tinymce-editor'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { leapsMeditationService } from '@/server-util/leaps-meditation-service'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import VideoQualityControl from '@/components/VideoQualityControl'
export default {
  props: ['currSelectedObj'],
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      dmAdminUtils: dmAdminUtils,
      constants: constants,
      maxLength: constants.Leaps_Title_Max_Length,
      disableInputBoxFor360And720: true,
      showAlertDialog: false,
      errorMsg: '',
      objToPass: {
        MeditationLibraryId: '',
        MeditationTitle: '',
        MeditationDescription: '',
        VideoUrl: '',
        HDVideoUrl: '',
        LowQualityVideoUrl: '',
        CaptionUrl: '',
        AudioUrl: '',
        UpdatedTS: '',
        CreatedTS: ''
      },
      showSpinner: false,
      hasCreatedLeapsMeditationUpdatedSuccessfully: false,
      createdObj: null,
      showConfirmationBox: false,
      prefixString: '',
      postString: ''
    }
  },
  name: 'update-leaps-meditation-overlay',
  methods: {
    performClickOperation: function (event, operationName) {
      switch (operationName) {
        case 'delete_vtt':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete existing caption file from '
          this.postString = '\'' + this.currSelectedObj.MeditationTitle + '\' meditation?'
          break
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
    },
    setDefaultValues: function () {
      this.objToPass.MeditationLibraryId = this.currSelectedObj.MeditationLibraryId
      this.objToPass.MeditationTitle = this.currSelectedObj.MeditationTitle
      this.objToPass.CreatedTS = this.currSelectedObj.CreatedTS
      this.objToPass.UpdatedTS = this.currSelectedObj.UpdatedTS
      if (this.currSelectedObj.MeditationDescription !== undefined && this.currSelectedObj.MeditationDescription !== 'undefined' && this.currSelectedObj.MeditationDescription !== null && this.currSelectedObj.MeditationDescription !== 'null' && this.currSelectedObj.MeditationDescription !== '' && this.stripHtml(this.currSelectedObj.MeditationDescription).trim().length !== 0) {
        setTimeout(() => {
          this.objToPass.MeditationDescription = dmAdminUtils.updateUrls(this.currSelectedObj.MeditationDescription)
        }, 500)
      } else {
        this.objToPass.MeditationDescription = ''
      }
      this.objToPass.VideoUrl = (this.currSelectedObj.VideoUrl !== null && this.currSelectedObj.VideoUrl !== 'null' && this.currSelectedObj.VideoUrl !== undefined && this.currSelectedObj.VideoUrl !== 'undefined' && this.currSelectedObj.VideoUrl !== '') ? this.currSelectedObj.VideoUrl : ''
      this.objToPass.HDVideoUrl = (this.currSelectedObj.HDVideoUrl !== null && this.currSelectedObj.HDVideoUrl !== 'null' && this.currSelectedObj.HDVideoUrl !== undefined && this.currSelectedObj.HDVideoUrl !== 'undefined' && this.currSelectedObj.HDVideoUrl !== '') ? this.currSelectedObj.HDVideoUrl : ''
      this.objToPass.LowQualityVideoUrl = (this.currSelectedObj.LowQualityVideoUrl !== null && this.currSelectedObj.LowQualityVideoUrl !== 'null' && this.currSelectedObj.LowQualityVideoUrl !== undefined && this.currSelectedObj.LowQualityVideoUrl !== 'undefined' && this.currSelectedObj.LowQualityVideoUrl !== '') ? this.currSelectedObj.LowQualityVideoUrl : ''
      this.objToPass.CaptionUrl = this.currSelectedObj.CaptionUrl
      this.objToPass.AudioUrl = (this.currSelectedObj.AudioUrl !== null && this.currSelectedObj.AudioUrl !== 'null' && this.currSelectedObj.AudioUrl !== undefined && this.currSelectedObj.AudioUrl !== 'undefined' && this.currSelectedObj.AudioUrl !== '') ? this.currSelectedObj.AudioUrl : ''
    },
    updateHideUpdateLeapsMeditationOverlayFlag: function (event) {
      var objToReturn = {
        closeOverlay: true,
        createdObj: null
      }
      this.$emit('emittedValue', objToReturn)
    },
    checkAndUpdateMasterLeapMeditationList: function () {
      const foundIndex = findIndex(this.$store.state.leapsMeditationList, (obj) => {
        return obj.MeditationLibraryId === this.objToPass.MeditationLibraryId
      })
      if (foundIndex > -1) {
        this.$store.state.leapsMeditationList[foundIndex] = this.createdObj
      }
    },
    updateVideoQualityValue (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.objToPass.LowQualityVideoUrl = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.objToPass.VideoUrl = videoUrl
          if (this.objToPass.VideoUrl.trim().length === 0) {
            this.objToPass.LowQualityVideoUrl = ''
            this.objToPass.HDVideoUrl = ''
            this.disableInputBoxFor360And720 = true
          } else {
            this.disableInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.objToPass.HDVideoUrl = videoUrl
          break
      }
    },
    updateLeapsMeditation: function () {
      var storeObj = this.$store
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' &&
          this.objToPass.MeditationLibraryId !== undefined && this.objToPass.MeditationLibraryId !== null && this.objToPass.MeditationLibraryId !== ''
        ) {
          var vttFileUrl = document.getElementById('vttFile').files[0]
          if (vttFileUrl === undefined || vttFileUrl === 'undefined' || vttFileUrl === null) {
            vttFileUrl = null
          }
          const videoDuration = parseInt(document.getElementById('videoTag').duration)
          const formData = new FormData()
          formData.append('MeditationLibraryId', this.objToPass.MeditationLibraryId)
          formData.append('MeditationTitle', this.objToPass.MeditationTitle)
          formData.append('MeditationDescription', (this.objToPass.MeditationDescription !== undefined && this.objToPass.MeditationDescription !== 'undefined' && this.objToPass.MeditationDescription !== null && this.objToPass.MeditationDescription !== 'null' && this.stripHtml(this.objToPass.MeditationDescription).trim().length !== 0) ? dmAdminUtils.removeTFromUrls(this.objToPass.MeditationDescription) : null)
          const videoUrl = this.objToPass.VideoUrl !== '' ? this.objToPass.VideoUrl.trim() : ''
          formData.append('VideoUrl', videoUrl)
          const hdVideoUrl = this.objToPass.HDVideoUrl !== '' ? this.objToPass.HDVideoUrl.trim() : ''
          formData.append('HDVideoUrl', hdVideoUrl)
          const lowVideoUrl = this.objToPass.LowQualityVideoUrl !== '' ? this.objToPass.LowQualityVideoUrl.trim() : ''
          formData.append('LowQualityVideoUrl', lowVideoUrl)
          const audioUrl = this.objToPass.AudioUrl !== '' ? this.objToPass.AudioUrl.trim() : null
          formData.append('AudioUrl', audioUrl)
          formData.append('VttFileInput', vttFileUrl)
          formData.append('Duration', videoDuration)
          this.$store.state.isLoading = true
          leapsMeditationService
            .updateLeapsMeditation(
              storeObj.state.access_token,
              formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.hasCreatedLeapsMeditationUpdatedSuccessfully = true
                this.createdObj = responseObj.data
                this.checkAndUpdateMasterLeapMeditationList()
                this.showAlertDialog = true
                this.errorMsg = '\'' + this.objToPass.MeditationTitle + '\' meditation updated successfully.'
                this.$store.state.isLoading = false
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined Update EXISTING LEAPS MEDITATION.'
          )
        }
      }
    },
    deleteVttFile (value) {
      var storeObj = this.$store
      this.showConfirmationBox = false
      if (value) {
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' &&
          this.objToPass.MeditationLibraryId !== undefined && this.objToPass.MeditationLibraryId !== null && this.objToPass.MeditationLibraryId !== ''
        ) {
          this.$store.state.isLoading = true
          leapsMeditationService
            .deleteMeditationVttFile(
              storeObj.state.access_token,
              this.objToPass.MeditationLibraryId
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.objToPass.CaptionUrl = null
                this.createdObj = this.objToPass
                this.checkAndUpdateMasterLeapMeditationList()
                this.$store.state.isLoading = false
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined DELETE VTT FILE.'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.hasCreatedLeapsMeditationUpdatedSuccessfully) {
        // AK: Hide Update LEAPS Meditation Overlay
        var objToReturn = {
          closeOverlay: true,
          createdObj: this.createdObj
        }
        this.$emit('emittedValue', objToReturn)
        this.hasCreatedLeapsMeditationUpdatedSuccessfully = false
        this.createdObj = null
      }
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    validateRequiredFieldBeforeSubmit: function () {
      var vttFileUrl = document.getElementById('vttFile').files[0]
      if (this.objToPass.MeditationTitle.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.AudioURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.AudioURLValue.trim()) || !dmAdminUtils.checkForAudioFileExtesion(this.AudioURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Audio url.'
        return false
      } else if (this.LowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.LowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.LowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Video url.'
        return false
      } else if (this.VideoURLValue.trim().length === 0 || !dmAdminUtils.isValidUrl(this.VideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.VideoURLValue.trim())) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Video url.'
        return false
      } else if (this.HDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.HDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.HDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Video url.'
        return false
      } else if (vttFileUrl !== undefined && vttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('vttFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .vtt file for caption.'
        return false
      }
      return true
    },
    checkVttFileExtesion: function (fileName) {
      var exts = ['.vtt']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'tinymce': tinymce,
    'confirmation-alert': ConfirmationOverlay,
    'video-quality-control': VideoQualityControl
  },
  computed: {
    VideoURLValue: {
      get: function () {
        return this.objToPass.VideoUrl
      },
      set: function (newValue) {
        this.objToPass.VideoUrl = newValue
      }
    },
    HDVideoURLValue: {
      get: function () {
        return this.objToPass.HDVideoUrl
      },
      set: function (newValue) {
        this.objToPass.HDVideoUrl = newValue
      }
    },
    LowVideoURLValue: {
      get: function () {
        return this.objToPass.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.objToPass.LowQualityVideoUrl = newValue
      }
    },
    AudioURLValue: {
      get: function () {
        return this.objToPass.AudioUrl
      },
      set: function (newValue) {
        this.objToPass.AudioUrl = newValue
      }
    }
  }
}
</script>

<style scoped>
.text-color-blue {
  color: blue;
}
.text-color-red {
  color: red !important;
}
.audio-width {
  width: -webkit-fill-available;
}
.create-lesson-label-text-style {
  color: #34495e;
  font-size: 12px;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-right-1Perc
{
    margin-right:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 15px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.opacity0Point5 {
  opacity: 0.5;
}
.orangeColor {
  color: #f39c12;
}
.margin-right-15px {
  margin-right: 15px;
}
</style>





// WEBPACK FOOTER //
// src/components/leaps/meditation/UpdateLeapsMeditationOverlay.vue